/**
 * Per-floor CSV runtime state (in-memory only, not persisted to map-editor-floors JSON).
 * Single source of truth lives in floorStore.csvRuntimeByFloor.
 */

import type { ParseResult } from '../../map-editor-features/csv/lib/csvParser'
import type { GroupedLayer } from '../../map-editor-features/csv/lib/layerGrouper'

export type CsvUploadState =
  | { status: 'idle' }
  | { status: 'uploading'; progress: number }
  | { status: 'parsing' }
  | { status: 'parsed'; fileName: string; rowCount: number; isRestored?: boolean }
  | { status: 'error'; message: string }

export interface CsvRuntimeState {
  uploadState: CsvUploadState
  file: File | null
  rawData: string | null
  parsedData: ParseResult | null
  groupedLayers: GroupedLayer[] | null
  selectedLayers: Set<string>
}

export function createEmptyCsvRuntime(): CsvRuntimeState {
  return {
    uploadState: { status: 'idle' },
    file: null,
    rawData: null,
    parsedData: null,
    groupedLayers: null,
    selectedLayers: new Set<string>(),
  }
}
